/**
 * Where a tour bubble about a SHELL target sits (nav item, profile, launcher).
 *
 * 1280 and up: the top bar's items get a bubble under the bar ('top-right');
 * the Empy and support launchers float at the bottom right, so theirs sits
 * above them ('bottom-right').
 *
 * Below 1280 the launchers and the profile avatar are docked in the layout's
 * compact header, at the TOP right (redesign PR3), so their bubble sits just
 * under the target with its tail up ('header'); the bottom nav's items keep
 * the bubble above the bottom nav ('bottom-right'). Before PR #1022's review
 * the docked targets kept the bottom bubble: the spotlight lit the header
 * while the tail pointed at the bottom nav.
 *
 * Its own module so OnboardingSpeechBubble.tsx exports a component only
 * (Fast Refresh).
 */
export type BubbleAnchor = 'bottom-right' | 'top-right' | 'header';

export const EMPY_LAUNCHER = '[data-onboarding="empy-button"]';
const LAUNCHERS = [EMPY_LAUNCHER, '[data-onboarding="support-chat"]'];
const PROFILE = '[data-onboarding="nav-profile"]';

export function shellBubbleAnchor(selector: string | undefined, isDesktop: boolean): BubbleAnchor {
  const isLauncher = selector !== undefined && LAUNCHERS.includes(selector);
  if (isDesktop) return isLauncher ? 'bottom-right' : 'top-right';
  return isLauncher || selector === PROFILE ? 'header' : 'bottom-right';
}
